module.exports = __webpack_public_path__ + "static/media/iphone_11_purple.b69d3f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_purple.png
// module id = 2070
// module chunks = 0